import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  taskItem: {
    padding: '8px',
    transition: 'all 0.3s ease',
    width: '100%',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: token.colorBgLayout
    }
  },

  checkbox: {
    height: '32px',
    width: '32px',
    '.ant-card-body': {
      padding: '4px 7px'
    }
  },

  divider: {
    height: '44px'
  },

  text: {
    maxWidth: '90%',
    width: '90%'
  },

  avatar: { flexDirection: 'row-reverse', textAlign: 'right' }
}))
